var map = {
	"./bottom-arrow.svg": "101d",
	"./calendar-light.svg": "4da0",
	"./calendar.svg": "76b2",
	"./clock-light.svg": "7e23",
	"./clock.svg": "3175",
	"./close.svg": "bb7c",
	"./download.svg": "8215",
	"./fullscreen.svg": "cc7c",
	"./heart-big.svg": "3deb",
	"./heart.svg": "6768",
	"./leaf-white.svg": "96f1",
	"./leaf.svg": "3cd9",
	"./leaf2-white.svg": "79b1",
	"./main.svg": "125a",
	"./maps.svg": "abcc",
	"./mask.svg": "08f9",
	"./person.svg": "7c75",
	"./qr.svg": "7e9f",
	"./switch-camera.svg": "f49f",
	"./tick-square.svg": "5a85"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4555";